import type { SubscriptionPlan } from '@/types'

/**
 * Planes MapeoData hardcodeados para la landing pública pre-registro.
 *
 * DECISIÓN KISS YAGNI integrada T-004 (2026-05-12, CEO):
 * Los 3 planes DEC-026 son estáticos hoy. La landing pública pre-registro
 * los muestra desde aquí (constante TS) para optimizar SEO + LCP — cero
 * fetch en landing. Una vez el usuario se registra y entra a la app
 * autenticada, los planes se consumen via `/api/v1/billing/plans` (con
 * JWT) para tener siempre la versión más actual de la BBDD.
 *
 * Si en el futuro hay pricing dinámico público (descuentos por código,
 * promociones temporales, A/B testing de precios pre-registro), se abrirá
 * un endpoint público dedicado `/api/v1/public/plans` con DEC propia.
 *
 * Mantener paridad MANUAL con la tabla `mp_subscription_plans` de la
 * BBDD MapeoData. Si Backend cambia precio/cupo de un plan, este archivo
 * se actualiza coordinadamente en el mismo commit.
 *
 * Última verificación empírica vs PostgREST: 2026-05-12 06:50 UTC (T-003).
 */
export const LANDING_PLANS: SubscriptionPlan[] = [
  {
    code: 'free',
    name_es: 'Gratuito',
    name_en: 'Free',
    monthly_price_eur: 0,
    monthly_leads_quota: 15,
    daily_quota_pct_limit: null,
    single_job_max_leads: 15,
    single_job_confirm_threshold: 15,
    single_job_2fa_threshold: null,
    carry_over_leads: false,
    features: {
      export_csv: true,
      export_excel: false,
      presets_sectoriales: false,
    },
    active: true,
    description_es:
      'Empieza a explorar MapeoData con 15 leads al mes. Sin tarjeta. Sin compromiso.',
    description_en:
      'Start exploring MapeoData with 15 leads/month. No credit card. No commitment.',
  },
  {
    code: 'starter',
    name_es: 'Starter',
    name_en: 'Starter',
    monthly_price_eur: 16.95,
    monthly_leads_quota: 200,
    daily_quota_pct_limit: 30,
    single_job_max_leads: 50,
    single_job_confirm_threshold: 50,
    single_job_2fa_threshold: null,
    carry_over_leads: false,
    features: {
      export_csv: true,
      export_excel: true,
      presets_sectoriales: true,
    },
    active: true,
    description_es:
      'Ideal para autónomos y micro-negocios que necesitan flujo constante de prospects.',
    description_en:
      'Perfect for freelancers and small businesses needing steady prospect flow.',
  },
  {
    code: 'pro',
    name_es: 'Pro',
    name_en: 'Pro',
    monthly_price_eur: 25.95,
    monthly_leads_quota: 800,
    daily_quota_pct_limit: 30,
    single_job_max_leads: 200,
    single_job_confirm_threshold: 200,
    single_job_2fa_threshold: null,
    carry_over_leads: false,
    features: {
      export_csv: true,
      export_excel: true,
      presets_sectoriales: true,
    },
    active: true,
    description_es: 'Para equipos comerciales que escalan prospección B2B con volumen.',
    description_en: 'For sales teams scaling B2B prospecting at volume.',
  },
]
